export const ORG_ID = process.env.REACT_APP_ORGANIZATION_ID!;
export const BRANCH_ID = process.env.REACT_APP_BRANCH_ID!;

export const CATEGORIES_COLLECTION = `organizations/${ORG_ID}/branches/${BRANCH_ID}/categories`;
export const PROJECTS_COLLECTION = `organizations/${ORG_ID}/branches/${BRANCH_ID}/projects`;
export const PRODUCTS_COLLECTION = `organizations/${ORG_ID}/branches/${BRANCH_ID}/products`;
export const SPECIFICATION_CATEGORIES_COLLECTION = `organizations/${ORG_ID}/branches/${BRANCH_ID}/specification_categories`;
export const SPECIFICATIONS_COLLECTION = `organizations/${ORG_ID}/branches/${BRANCH_ID}/specifications`;
export const ORDERS_COLLECTION = `organizations/${ORG_ID}/branches/${BRANCH_ID}/orders`;
